import React from 'react'
import PropTypes from 'prop-types'

// FA Free only ships fa-xmark as solid, so this outline variant is hand-rolled.
const PATH_D = 'M6 18L18 6M6 6L18 18'

const XmarkIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height="1em"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={PATH_D}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

XmarkIcon.propTypes = {
  className: PropTypes.string
}

XmarkIcon.defaultProps = {
  className: ''
}

export default XmarkIcon
